import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "/assets/images/Logo_d_immeuble_moderne_en_or-1758887759495.png"
      }}
      {...props}
    />
  );
}

export default Image;
